import { css } from '@emotion/react';
import { type FC } from 'react';
import { ButtonStyle } from '~/_shared/baseComponents/buttons/button/button.types';
import { useTranslation } from '~/_shared/utils/hooks';
import { UploadMethodComponent } from './uploadMethod.component';

const secondaryUploadContainerStyle = css({
  display: 'flex',
  gap: 16,
});

const uploadMethodStyle = css({
  width: '50%',
});

type UploadMethodsProps = Readonly<{
  isLoading: boolean;
  onStartBlankClick: () => void;
  onStartGoogleSheetsClick: () => void;
}>;

export const UploadMethodsComponent: FC<UploadMethodsProps> = ({
  isLoading,
  onStartBlankClick,
  onStartGoogleSheetsClick,
}) => {
  const [t] = useTranslation();

  return (
    <div css={secondaryUploadContainerStyle}>
      <UploadMethodComponent
        buttonLabel={t('Start Blank')}
        buttonStyle={ButtonStyle.Secondary}
        css={uploadMethodStyle}
        isDisabled={isLoading}
        onClick={onStartBlankClick}
        title={t('Manually create a New Map from scratch with no data set.')}
      />
      <UploadMethodComponent
        buttonLabel={t('Google Sheets')}
        buttonStyle={ButtonStyle.Success}
        css={uploadMethodStyle}
        isDisabled={isLoading}
        onClick={onStartGoogleSheetsClick}
        title={t('Create a New Map with Google Sheets.')}
      />
    </div>
  );
};
